import React, { PropTypes } from 'react';
import classNames from 'classnames';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

import Link from 'components/Link';
import './style.scss';

const MainNavigationItem = props => {
  const {
    to = "_",
    hideForTablet = false,
    showForTablet = false,
    type,
    iconUrl,
    dropdownRef,
    isChatEnabled,
    isOnline,
    ...otherProps
  } = props;

  const className = classNames(
    'MainNavigationItem',
    type,
    {
      'hide-for-tablet': hideForTablet,
      'show-for-tablet': showForTablet,
      'is-chat-enabled': isChatEnabled,
      'is-online': isOnline
    }
  );

  const trigger = (
    <Link {...otherProps} to={to} activeClassName="is-active">
      <img src={iconUrl} />
    </Link>
  );

  return (
    <li className={className}>
      {(() => {
        if(props.children) {
          return (
            <Dropdown ref={dropdownRef} className="show-for-tablet">
              <DropdownTrigger>
                <span className="dropdown-trigger-text">
                  <img src={iconUrl} />
                </span>
              </DropdownTrigger>

              <DropdownContent>
                <div className="dropdown-content-inner">
                  {props.children}
                </div>
              </DropdownContent>
            </Dropdown>
          );
        }
        else {
          return trigger;
        }
      })()}

    </li>
  );
};

MainNavigationItem.propTypes = {
  type: PropTypes.string,
  iconUrl: PropTypes.string,
  dropdownRef: PropTypes.func,
  hideForTablet: PropTypes.bool,
  to: PropTypes.string,
  showForTablet: PropTypes.bool,
  isOnline: PropTypes.bool,
  isChatEnabled: PropTypes.bool,
  children: PropTypes.element
};

export default MainNavigationItem;



/** WEBPACK FOOTER **
 ** ./src/members/Main/MainNavigation/MainNavigationItem/index.js
 **/